import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgForm } from "@angular/forms";
import _ from "lodash";
import { first } from "rxjs/operators";

import { HelperService } from "@services/helper.service";
import { CreditStatusLogsCanvasService } from "./CreditStatusLogsCanvas.service";

@Component({
	selector: "CreditStatusLogsCanvas",
	templateUrl: "./CreditStatusLogsCanvas.component.html",
	styleUrls: ["./CreditStatusLogsCanvas.component.scss"],
})
export class CreditStatusLogsCanvas implements OnInit {
	@Input() currentCreditHold;
	@Input() isHideModal;

	LODASH = _;
	isHistoryCollapse: Boolean = false;
	isApproversCollapse: Boolean = false;

	selectedApproverFrom = null;

	constructor(
		private helperService: HelperService,
		public creditStatusLogsCanvasService: CreditStatusLogsCanvasService
	) {}
	ngOnInit(): void {}
	ngOnChanges() {
		this.selectedApproverFrom = null;
	}
	ngOnDestroy() {}

	reassignApprover($event) {
		let params = {
			credit_hold: this.currentCreditHold,
			from_approver: this.selectedApproverFrom,
			to_approver: _.get($event, "data.engineer"),
		};

		this.creditStatusLogsCanvasService
			.reassignApprover(params)
			.pipe(first())
			.subscribe((response: any) => {
				this.helperService.successMessage(response.message);
				this.selectedApproverFrom = null;
			});
	}

	getReassignText() {
		return `Selected Approver '${_.get(
			this.selectedApproverFrom,
			"full_name"
		)}'`;
	}

	isStatusReleased() {
		return _.get(this.currentCreditHold, "status_reason") == "released";
	}
}
